import { CurrencyPipe } from "@angular/common";
import { Component, OnInit, ViewChild, ViewEncapsulation, Renderer2 } from "@angular/core";
import { LandingService } from "../landing.service";
import { Property, Amenities } from "app/modules/admin/properties/property.model";
import { ActivatedRoute, Router } from "@angular/router";
import { CoreConfigService } from "@core/services/config.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Mortgage, ValuationMortgage } from "app/modules/admin/utilidades/utilidades.model";
import { UtilitiesService } from "app/modules/admin/utilidades/utilities.service";
import { environment } from "environments/environment";
import { User } from "../../../../auth/models/user";
import { DomSanitizer } from "@angular/platform-browser";
import { PropertyService } from "../../../../../app/modules/admin/properties/property.service";
// import { Lightbox } from 'ngx-lightbox';
// import { LightboxConfig } from 'ngx-lightbox';
// import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from 'ng-gallery';
import { NgxGalleryComponent, NgxGalleryOptions } from "@kolkov/ngx-gallery";
import { NgxGalleryImage } from "@kolkov/ngx-gallery";
import { NgxGalleryAnimation } from "@kolkov/ngx-gallery";
import { Meta } from "@angular/platform-browser";

declare var google: any;

@Component({
  selector: "app-property-details",
  templateUrl: "./property-details.component.html",
  styleUrls: ["./property-details.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PropertyDetailsComponent implements OnInit {
  @ViewChild("gallery") gallery: NgxGalleryComponent;
  galleryOptions: NgxGalleryOptions[];
  galleryOptionsT3: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  videoUrlSafe;

  property: Property = {
    id: 0,
    property_images: [],
    state: null,
    province: null,
    title: " ",
    exactLocation: false,
  };

  map;

  withReal: boolean;

  // userLoggeado: User;

  valuation: ValuationMortgage = {
    price: null,
    priceText: "",
    downPayment: null,
    downPaymentText: "",
    time: null,
  };

  mortgageSetup: Mortgage = {
    interest: null,
    cat: null,
    commissionPercentage: null,
    taxes: null,
  };

  stateName: string = "";
  provinceName: string = "";
  cpName: number;
  suburbName: string = "";
  tradeName: string = "";
  amenities_base: Amenities[];
  amenities_ops: Amenities[];
  url = environment.URL_AWS;
  urlLanding = environment.URL_LANDING;
  urlSubDomain = environment.URL_SUBDOMAIN_LANDING;
  domain: string = "";
  isVisible: boolean = false;

  paths: string[] = [];
  carrusel: string[] = [];
  firstImage: string = "";
  secondImage: string = "";
  thirdImage: string = "";
  fourthImage: string = "";
  fifthImage: string = "";
  sixImageExist: boolean;

  prestamo: number;
  mensualidad: number;

  comisionApertura: number;
  impuestos: number;
  totalEnganche: number;

  onlyDetails: boolean;
  urlShareCopy: string;
  small_contact = false;

  loading = true;

  showGallery(indexImg: number) {
    this.gallery.openPreview(indexImg);
  }

  modalOpenLink(modallink, type: number) {
    if (type == 1) {
      this.urlShareCopy = "https://back.inmoapp.mx/" + this.property["real_estate"]["domain"] + "/" + this.property.id;
    }

    this.modalService.open(modallink, {
      size: "lg",
    });
  }

  plazos = [
    { name: "15", value: 15 },
    { name: "20", value: 20 },
  ];
  plazosLoading;
  config;
  public listener: () => void;

  public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).src = "../../../../../assets/images/noImage.png";
  }

  constructor(
    private sanitizer: DomSanitizer,
    private _landingService: LandingService,
    private _router: Router,
    private _route: ActivatedRoute,
    private modalService: NgbModal,
    private _currencyPipe: CurrencyPipe,
    private _coreConfigService: CoreConfigService,
    private _propertyService: PropertyService,
    private renderer: Renderer2,
    private meta: Meta
  ) {
    this.sixImageExist = false;
    this.onlyDetails = true;

    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };

    var host = window.location.host;
    console.log("window.location.host", window.location.host);
    const domain = host.split(".")[1];
    let data;
    if (domain == "in-mo" || domain == "inmoapp") {
      data = {
        domain: host.split(".")[0],
      };
    } else {
      data = {
        domain: environment.DOMAIN,
      };
    }
    this._landingService.getConfig(data).then(
      (data: any) => {
        console.log(data);
        this.config = data;

        const mapClass = document.getElementById("mapClass");
        const shareClass = document.getElementById("shareClass");

        if (mapClass != null) {
          if (this.config?.theme === 1) {
            mapClass.classList.add("col-md-6");
          }
        }

        if (shareClass != null) {
          if (this.config?.theme === 1) {
            shareClass.classList.add("col-md-6");
          }
        }

        this.iniData();
      },
      (error: any) => {
        console.log(error);
      }
    );

    this._landingService.getValuesAssessment().then(
      (data: Mortgage) => {
        this.mortgageSetup = data;
        this.mortgageSetup.interest = (Number(this.mortgageSetup.interest) / 10 + 1) / 100;
        this.mortgageSetup.commissionPercentage = Number(this.mortgageSetup.commissionPercentage) / 100;
        this.mortgageSetup.taxes = Number(this.mortgageSetup.taxes) / 100;
        this.mortgageSetup.cat = Number(this.mortgageSetup.cat);
      },
      (error: any) => {
        console.log(error);
      }
    );

    this.checkViewSize();
  }

  watchVideo() {
    console.log("this.property.videoUrl", this.property.videoUrl);
    window.open(this.property.videoUrl, "_blank");
  }

  iniData() {
    this.galleryOptions = [
      {
        image: false,
        thumbnails: false,
        width: "0",
        height: "0",
        previewZoom: true,
        previewBullets: true,
        previewKeyboardNavigation: true,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
      },
    ];

    this.galleryOptionsT3 = [
      {
        imageAutoPlay: true,
        imageAutoPlayPauseOnHover: true,
        width: "1400px",
        height: "800px",
        thumbnailsColumns: 4,
        previewZoom: true,
        previewBullets: true,
        previewKeyboardNavigation: true,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
        thumbnailsPercent: 25,
        thumbnailsMargin: 10,
        thumbnailMargin: 10,
        imageAnimation: NgxGalleryAnimation.Slide,
      },
      // max-width 800
      {
        breakpoint: 800,
        width: "100%",
        height: "600px",
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 0,
        thumbnailMargin: 0,
        previewZoom: true,
        previewBullets: true,
        previewKeyboardNavigation: true,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false,
        previewZoom: true,
        previewBullets: true,
        previewKeyboardNavigation: true,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
      },
    ];

    let i = 0;
    const id = this._route.snapshot.paramMap.get("id");

    this._landingService.getPropertyId(parseInt(id)).then(
      (resp: any) => {
        this.property = resp;
        console.log("file: property-details.component.ts:239 ~ PropertyDetailsComponent ~ ngOnInit ~ resp", resp);

        this.videoUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
          "https://www.youtube.com/embed/" + this.youtube_parser(this.property.videoUrl)
        );
        this.property.totalCommission = this.property.totalCommission / 100;
        this.property.realEstateCommission = this.property.realEstateCommission / 100;
        this.property.agentCommission = this.property.agentCommission / 100;
        this.property.sharedCommission = this.property.sharedCommission / 100;

        this.tradeName = resp.real_estate.tradeName;
        this.stateName = this.property.state.name;
        this.cpName =
          this.property?.suburb?.postalCode != null || this.property?.suburb?.postalCode != undefined
            ? this.property.suburb.postalCode
            : 0;
        this.suburbName =
          this.property?.suburb?.suburb != null || this.property?.suburb?.suburb != undefined
            ? this.property.suburb.suburb.trim()
            : "";
        this.provinceName = this.property.province.name;

        this.galleryImages = [];
        this.property.propertyImages.forEach((e) => {
          this.carrusel.push(e.path);
          if (i < 6 && this.config?.theme !== 3) {
            this.paths.push(e.path);
          }

          let imgG;

          imgG = {
            small: e.path,
            medium: e.path,
            big: e.path,
          };
          this.galleryImages.push(imgG);

          i++;
        });

        if (this.paths.length > 5 || this.property.videoUrl) {
          this.sixImageExist = true;
        }

        this.firstImage = this.paths[0];

        this.secondImage = this.paths[1];

        this.thirdImage = this.paths[2];

        this.fourthImage = this.paths[3];

        this.fifthImage = this.paths[4];

        this.amenities_base = [...this.property.amenities.filter((x) => x.tipo === 1)];
        this.amenities_base = this.amenities_base.filter((x) => x.cantidad > 0);

        this.amenities_ops = [...this.property.amenities.filter((x) => x.tipo === 2)];
        // this.amenities_ops = this.amenities_ops.filter(x => x.cantidad > 0);

        if (!this.property.pet_friendly) {
          this.amenities_ops = this.amenities_ops.filter((item) => item.name !== "Pet Friendly");
        }
        console.log("this.amenities_ops", this.amenities_ops);
        this.amenities_ops.filter((x) => {
          if (x.name == "Pet Friendly" && this.property.pet_friendly) {
            let index = this.amenities_ops.findIndex((x) => x.id == -1);
            this.amenities_ops[index].selected = true;
          }
        });
        console.log(this.amenities_base);
        this.valuation.priceText = this._currencyPipe.transform(this.property.price, " ", "symbol", "1.2-2");
        this.valuation.price = this.property.price;
        this.property.price.toString();
        this.loading = false;

        this.initMap(); //
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  ngOnInit(): void {}

  youtube_parser(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/; //Expresión regular para buscar el ID del video en la URL
    var match = url?.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  }

  getCoinTypeName(coinType: number): string {
    switch (coinType) {
      case 1:
        return "MXN";
      case 2:
        return "USD";
      case 3:
        return "EUR";
      case 4:
        return "JPY";
      case 5:
        return "GBP";
      case 6:
        return "AUD";
      case 7:
        return "CAD";
      case 8:
        return "CHF";
      case 9:
        return "SGD";
      // Agrega más casos según tus necesidades
      default:
        return "MXN";
    }
  }

  initMap() {
    const icon = {
      url: "assets/icon/home.png",
      scaledSize: new google.maps.Size(50, 50),
    };
    let lat;
    let lng;
    if (this.property.exactLocation) {
      lat = Number(this.property.latitude);
      lng = Number(this.property.longitude);
    } else {
      lat = Number(this.property.latitude) + 0.0005;
      lng = Number(this.property.longitude) - 0.0005;
    }
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: lat, lng: lng },
      zoom: 15,
      panControl: false,
      streetViewControl: false,
      scaleControl: false,
      overviewMapControl: false,
      mapTypeControl: false,
    });

    // this.map.addListener("idle", () => {
    // });
    setTimeout(() => {
      if (this.property.exactLocation) {
        const marker = new google.maps.Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
          icon,
        });
      } else {
        const cityCircle = new google.maps.Circle({
          strokeColor: "#0D426E",
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: "#1A7DB6",
          fillOpacity: 0.25,
          map: this.map,
          center: { lat: lat, lng: lng },
          radius: 250,
        });
      }
    }, 500);
  }

  redirect(modalBasic): void {
    if (this.property.operationType === "Renta") {
    } else if (this.property.operationType === "Venta") {
      this.modalService.open(modalBasic, {
        centered: true,
        size: "lg",
      });
    }
  }

  // favorite(pro: Property) {

  //   this._propertyService.setFavoAgent(pro.id, this.userLoggeado.agentId).then(
  //     (resp: any) => {
  //       pro.landingFavorite = !pro.landingFavorite;
  //     }, (error: any) => {
  //       console.log(error);
  //     }
  //   );
  // }

  linkTo(url): void {
    window.open(url, "_blank");
  }

  verMas(modalBasic2): void {
    this.modalService.open(modalBasic2, {
      centered: true,
      size: "xl",
    });
  }

  makeV(): void {
    this.isVisible = true;
    if (this.valuation.priceText !== "" && this.valuation.downPaymentText !== "" && this.valuation.time !== null) {
      let tenPorcent = (this.valuation.downPayment * 100) / this.valuation.price;
      if (tenPorcent >= 10) {
        this.prestamo = this.valuation.price - this.valuation.downPayment;
        this.mensualidad = (((this.prestamo * this.mortgageSetup.interest) / this.valuation.time) * 111.24) / 12;
        this.comisionApertura = this.valuation.price * this.mortgageSetup.commissionPercentage;
        this.impuestos = this.valuation.price * this.mortgageSetup.taxes;
        this.totalEnganche = this.valuation.downPayment + this.comisionApertura + this.impuestos;
      }
    }
  }

  clean(): void {
    this.valuation.downPaymentText = "";
    this.valuation.time = null;
    this.prestamo = null;
    this.mensualidad = null;
    this.comisionApertura = null;
    this.impuestos = null;
    this.totalEnganche = null;
    this.isVisible = false;
  }

  redirectMap(): void {
    if (this.property.exactLocation) {
      window.open(
        "http://www.google.com/maps/place/" + this.property.latitude + "," + this.property.longitude,
        "_blank"
      );
    } else {
      let text =
        this.property?.suburb?.suburb + " " + this.property?.suburb?.postalCode + " " + this.property.province.name;
      text = text.replaceAll(" ", "%20");
      window.open("http://www.google.com/maps/place/" + text, "_blank");
    }
  }

  sendMail(): void {
    window.open("mailto:" + this.property.emailContact + "?subject=" + this.property.emailContact, "_blank");
  }

  sendWhatsApp(): void {
    if (this.config?.phoneWhatsApp) {
      const lada = this.config.lada_phoneWhatsApp ? this.config.lada_phoneWhatsApp : "52";
      window.open(`https://wa.me/${lada}${this.config.phoneWhatsApp}`, "_blank");
      return;
    }
    if (this.property.whatsContact) {
      const lada = this.property?.lada ? this.property.lada : "52";
      window.open(`https://wa.me/${lada}${this.property.whatsContact}`, "_blank");
    }
  }

  transformAmount(element, type): void {
    if (element.target.value) {
      if (type === 1) {
        this.valuation.price = parseFloat(this.valuation.priceText.replace(",", ""));
        this.valuation.priceText = this._currencyPipe.transform(this.valuation.price, " ", "symbol", "1.2-2");
        element.target.value = this.valuation.priceText;
      }
      if (type === 2) {
        this.valuation.downPayment = parseFloat(this.valuation.downPaymentText.replace(",", ""));
        this.valuation.downPaymentText = this._currencyPipe.transform(
          this.valuation.downPayment,
          " ",
          "symbol",
          "1.2-2"
        );
        element.target.value = this.valuation.downPaymentText;
      }
    }
  }

  public onQtrInputChange(event: any) {
    if (event.replace(/\D/g, "") === "") {
      this.valuation.downPayment = 0;
    } else {
      this.valuation.downPayment = Number(event.replace(/\D/g, ""));
    }
  }

  public onFocusCommaInput() {
    this.listener = this.renderer.listen("window", "keyup", (event) => {
      this.valuation.downPaymentText = (<HTMLInputElement>document.getElementById("downPayment")).value.replace(
        /[^\d,]/g,
        ""
      );
    });
  }

  public onBlurCommaInput() {
    this.listener();
  }

  checkViewSize() {
    // this.getScreenWidth = window.innerWidth;
    // this.getScreenHeight = window.innerHeight;
    let screen_width = window.innerWidth;
    console.log("screen_width", screen_width);
    if (screen_width < 500) this.small_contact = true;
    else this.small_contact = false;
  }
}
